import axios from "axios";
import { uri } from "../constants";

// Function to create a new release using the backend API
export const createRelease = async (releaseData) => {
  try {
    const response = await axios.post(`${uri}/releases`, releaseData);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const createBulkReleases = async (releasesData) => {
  try {
    const response = await axios.post(`${uri}/releases/bulk`, releasesData);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getAllReleases = async () => {
  try {
    const response = await axios.get(`${uri}/releases/all`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getReleases = async (params = {}) => {
  try {
    // Set default values for pagination
    const {
      page = 1,
      limit = 10,
      title,
      upc,
      userId,
      status,
      search,
      sortBy = "title",
      sortOrder = "asc",
    } = params;

    // Build query string with parameters
    const queryParams = new URLSearchParams();
    queryParams.append("page", page);
    queryParams.append("limit", limit);

    if (title) queryParams.append("title", title);
    if (upc) queryParams.append("upc", upc);
    if (userId) queryParams.append("userId", userId);
    if (status) queryParams.append("status", status);
    if (search) queryParams.append("search", search);
    if (sortBy) queryParams.append("sortBy", sortBy);
    if (sortOrder) queryParams.append("sortOrder", sortOrder);

    const response = await axios.get(
      `${uri}/releases?${queryParams.toString()}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getUserReleases = async (uid, params = {}) => {
  try {
    const {
      page = 1,
      limit = 1000000,
      title,
      upc,
      userId,
      status,
      search,
      sortBy = "title",
      sortOrder = "asc",
    } = params;

    // Build query string with parameters
    const queryParams = new URLSearchParams();
    queryParams.append("page", page);
    queryParams.append("limit", limit);

    if (title) queryParams.append("title", title);
    if (upc) queryParams.append("upc", upc);
    if (userId) queryParams.append("userId", userId);
    if (status) queryParams.append("status", status);
    if (search) queryParams.append("search", search);
    if (sortBy) queryParams.append("sortBy", sortBy);
    if (sortOrder) queryParams.append("sortOrder", sortOrder);
    const response = await axios.get(
      `${uri}/releases/users/${uid}?${queryParams.toString()}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateRelease = async (releaseId, releaseData) => {
  try {
    const response = await axios.put(
      `${uri}/releases/${releaseId}`,
      releaseData
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getRelease = async (releaseId) => {
  const response = await axios.get(`${uri}/releases/${releaseId}`);
  return response.data.release;
};
